import React, { useEffect } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import './scss/style.scss';
import PrivateRoute from './containers/PrivateRoute';
import { useAuth } from './hooks/useAuth';
import { fetchUser } from './slices/userSlice';
import { useDispatch } from 'react-redux';
import { setCodeErrorHandler } from './util/request';
import AppAlert from 'src/containers/AppAlert';
import { SnackbarProvider } from 'notistack';

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
);

// Containers
const TheLayout = React.lazy(() => import('./containers/TheLayout'));
const Login = React.lazy(() => import('./containers/login/Login'));
const DevView = React.lazy(() => import('./views/dev/DevView'));

export const DEV_VIEW_STORAGE_KEY = 'devView';

export const shouldShowDevView = () => {
  const enabled =
    String(process.env.REACT_APP_DEV_VIEW).trim().toLowerCase() === 'true';

  if (!enabled) return false;

  try {
    return window.localStorage.getItem(DEV_VIEW_STORAGE_KEY) !== 'false';
  } catch (error) {
    return true;
  }
};

const RecruiterApp = () => {
  const { logout, getPersistedToken, setAuthToken } = useAuth();
  const dispatch = useDispatch();

  useEffect(() => {
    setCodeErrorHandler(401, logout);

    let token = null;
    if ((token = getPersistedToken())) {
      setAuthToken(token);
      dispatch(fetchUser(token));
    }
  });

  return (
    <>
      <BrowserRouter>
        <React.Suspense fallback={loading}>
          <SnackbarProvider />
          <Switch>
            <Route
              path="/login"
              exact={true}
              name="Login"
              render={(props) => <Login {...props} />}
            />
            <PrivateRoute path="/">
              <TheLayout />
            </PrivateRoute>
          </Switch>
        </React.Suspense>
      </BrowserRouter>
      <AppAlert />
    </>
  );
};

const App = () => {
  if (shouldShowDevView()) {
    return (
      <React.Suspense fallback={loading}>
        <DevView />
      </React.Suspense>
    );
  }

  return <RecruiterApp />;
};

export default App;
